import { Component, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: true,
    imports: []
})
export class UnauthorizedComponent {

    private readonly authService = inject(AuthService);

    constructor() {
        this.authService.logout();
    }
}
